import {
  FormControlLabel,
  Checkbox,
  Box,
  Tooltip,
  IconButton,
  TextField,
} from '@mui/material';
import * as React from 'react';
import { RotateCcw } from 'react-feather';
import analyticsService from '~/src/services/analytics';
import { Edited } from '../Edit';

type MultipleChoiceIndividualInputProps = {
  label: string;
  isChecked: boolean;
  isEdited: boolean;
  onChange: () => void;
  onRevert: () => void;
  onBlur: () => void;
  textToMergeValue: string;
  onChangeTextToMergeValue: (value: string) => void;
  showTextToMerge?: boolean;
};

export const MultipleChoiceIndividualInput = ({
  label,
  isChecked,
  isEdited,
  onChange,
  onRevert,
  onBlur,
  textToMergeValue,
  onChangeTextToMergeValue,
  showTextToMerge,
}: MultipleChoiceIndividualInputProps) => {
  const isInErrorState = !textToMergeValue;

  const revertButton = (
    <Tooltip title={'Reset Changes'}>
      <IconButton
        data-testid={`${textToMergeValue}-reset-changes`}
        sx={(theme) => ({
          marginLeft: 1,
          color: theme.palette.grey[900],
          width: 24,
          height: 24,
        })}
        onClick={onRevert}
      >
        <RotateCcw />
      </IconButton>
    </Tooltip>
  );

  return (
    <>
      <FormControlLabel
        sx={{ marginLeft: 0 }}
        slotProps={{ typography: { variant: 'body1' } }}
        onChange={() => onChange()}
        checked={isChecked}
        label={<Box pl={1}>{label}</Box>}
        control={<Checkbox disabled={isInErrorState} />}
      />

      {showTextToMerge ? (
        <Box>
          <TextField
            error={isInErrorState}
            size={'small'}
            value={textToMergeValue}
            onChange={(e) => {
              analyticsService.track('Populate Page Field Interaction', {
                fieldType: 'multi_select',
                textToMergeValueEdited: true,
              });
              onChangeTextToMergeValue(e.target.value);
            }}
            onBlur={onBlur}
            helperText={
              isInErrorState ? (
                <Box
                  component={'span'}
                  display={'flex'}
                  justifyContent={'space-between'}
                >
                  <Box component={'span'}>
                    Please enter a custom value or select reset changes
                  </Box>
                  {revertButton}
                </Box>
              ) : undefined
            }
            fullWidth
            multiline
          />
          <Box
            py={1}
            visibility={isEdited && !isInErrorState ? 'visible' : 'hidden'}
            display={'flex'}
            justifyContent={'flex-end'}
            alignItems={'center'}
          >
            <Edited />
            {revertButton}
          </Box>
        </Box>
      ) : null}
    </>
  );
};
